import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useSmartnewsBusinessManagerStore = defineStore({
  id: 'smartnewsBusinessManagerStore',
  state: () => ({
    smartnewsBusinessManagers: [],
    smartnewsBusinessManagersLoading: false,
    error: null,
  }),
  actions: {
    async getSmartnewsBusinessManagers(filters = {}, withRelation = undefined) {
      this.error = null
      this.smartnewsBusinessManagersLoading = true

      try {
        const {data} = await axios.get('smart-news/business-managers', {
          params: {...filters, with: withRelation},
        })

        this.smartnewsBusinessManagers = data

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.smartnewsBusinessManagersLoading = false
      }
    },
  },
})
